import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import Head from "next/head";
import { GetServerSideProps } from "next";
import usePolicyScroll from "@/hooks/usePolicyScroll";
import MarkdownContent from "@/containers/policy/MarkDownContent";
import FooterBtn from "@/containers/policy/FooterBtn";
import { fetchCmsEduArticleBySlug } from "@/service/cms.service";

export default function PrivacyPolicyAndPersonalInfo({ post = { content: "", title: "" } }) {
	const { btnText, containerRef, handleRead } = usePolicyScroll();

	return (
		<>
			<Head>
				<title>{post.title}</title>
			</Head>

			<div className="mx-auto flex h-full w-full max-w-screen-sm flex-col">
				<div className="flex-1 overflow-y-auto px-4 pt-4" ref={containerRef}>
					<MarkdownContent childrenStr={post.content} />
				</div>
				<FooterBtn onClick={handleRead}>{String(btnText)}</FooterBtn>
			</div>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { locale } = context;

	try {
		const res = await fetchCmsEduArticleBySlug("personal-info-collection-statement", locale || "en");
		if (!res) throw new Error("No article found");
		return {
			props: {
				post: { ...res },
				...(await serverSideTranslations(locale || "en", ["policy"])),
			},
		};
	} catch (error) {
		return {
			notFound: true,
		};
	}
};
